import React from 'react';
import { NeedsOnboardingInformation, usePageRequireAuth } from '../../client/hooks';
import { DashboardFullPageLoading } from '../../components/common/GenericFullPageLoading';
import { DashboardLayout } from '../../components/common/layout/DashboardLayout';
import { Espin_Role_Enum } from '../../generated/spin-graphql';
import { CollegeFollowing } from '../../components/dashboard/following/CollegeFollowing';
import { ParentFollowing } from '../../components/dashboard/following/ParentFollowing';
import { useAppState } from '../../client/providers/AppProvider';
import { PlayerFollowingContainer } from '../../components/dashboard/following/PlayerFollowingContainer';
import { HighSchoolFollowing } from '../../components/dashboard/following/HighSchoolFollowing';

export default function FollowingPage() {
    const { user } = useAppState();
    usePageRequireAuth({});
    if (!!!user) {
        return <DashboardFullPageLoading />;
    }

    return (
        <DashboardLayout pageTitle="Following">
            <NeedsOnboardingInformation>
                {user.role === Espin_Role_Enum.EspinPlayerUser && <PlayerFollowingContainer />}
                {user.role === Espin_Role_Enum.EspinCollegeUser && <CollegeFollowing />}
                {user.role === Espin_Role_Enum.EspinParentUser && <ParentFollowing />}
                {user.role === Espin_Role_Enum.EspinHighschoolUser && <HighSchoolFollowing />}
            </NeedsOnboardingInformation>
        </DashboardLayout>
    );
}
